import Head from 'next/head';
import { FC } from 'react';

export interface Breadcrumb {
  name: string;
  url: string;
}

interface BreadcrumbDataProps {
  breadcrumbList: Breadcrumb[];
}

const makeBreadcrumbSchema = (breadcrumbList: Breadcrumb[]) => {
  const breadcrumbItem = breadcrumbList.map((it, idx) => ({
    '@types': 'ListItem',
    'position': idx + 1,
    'name': it.name,
    'item': it.url,
  }));

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': breadcrumbItem,
  };
};

export const BreadcrumbData: FC<BreadcrumbDataProps> = ({ breadcrumbList }) => {
  return (
    <Head>
      <script
        key="Veroo-Breadcrumb"
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: JSON.stringify(makeBreadcrumbSchema(breadcrumbList)) }}
      />
    </Head>
  );
};
